<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div
        class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <!-- <div class="w-30">
                <img src="assets/images/logo/logo.svg" />
            </div> -->

            <!-- Title -->
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">
                {{ "sign-in.sign-in" | transloco }}
            </div>

            <!-- Alert -->
            <fuse-alert class="mt-8 -mb-4" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false"
                [type]="alert.type" [@shake]="alert.type === 'error'">
                {{ alert.message }}
            </fuse-alert>

            <!-- Вход form -->
            <form class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">
                <!-- Email field -->
                <div class="w-full flex flex-col gap-2">
                    <label class="text-sm font-medium text-gray-700" for="username">
                        {{ "sign-in.login" | transloco }}
                    </label>
                    <input id="username" pInputText [formControlName]="'username'" autocomplete="username" />
                    <small class="p-error" *ngIf="
      signInForm.get('username').hasError('required') &&
      (signInForm.get('username').dirty || signInForm.get('username').touched)
    ">
                        {{ "sign-in.login_required" | transloco }}
                    </small>
                    <small class="p-error" *ngIf="
      signInForm.get('username').hasError('username') &&
      (signInForm.get('username').dirty || signInForm.get('username').touched)
    ">
                        {{ "sign-in.incorrect_login" | transloco }}
                    </small>
                </div>

                <!-- Password field -->
                <div class="w-full flex flex-col gap-2 mt-6">
                    <label class="text-sm font-medium text-gray-700" for="password">
                        {{ 'sign-in.password' | transloco }}
                    </label>

                    <div class="relative w-full">
                        <input [formControlName]="'password'" pPassword [feedback]="false"
                            [type]="showPassword ? 'text' : 'password'" id="password" autocomplete="current-password"
                            class="w-full rounded border border-gray-300 px-3 py-2 pr-10 focus:border-blue-500 focus:outline-none" />
                        <button type="button" (click)="toggleShowPassword()"
                            class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700"
                            aria-label="Toggle password visibility">
                            <i class="pi pi-eye" *ngIf="showPassword"></i>
                            <i class="pi pi-eye-slash" *ngIf="!showPassword"></i>
                            <!-- swap the icons above for whatever you prefer -->
                        </button>
                    </div>

                    <small class="p-error" *ngIf="
                        signInForm.get('password').hasError('required') &&
                        (signInForm.get('password').dirty || signInForm.get('password').touched)
                    ">
                        {{ 'sign-in.password_required' | transloco }}
                    </small>
                </div>

                <!-- Submit button -->
                <button pButton [loading]="signInForm.disabled" type="submit"
                    class="w-full mt-6 flex items-center justify-center gap-2 bg-" [disabled]="signInForm.disabled"
                    (click)="signIn()">
                    <span *ngIf="!signInForm.disabled">
                        {{ 'sign-in.sign-in' | transloco }}
                    </span>
                </button>
                <div class="w-full p-3 text-center">
                    <languages></languages>
                </div>
            </form>
        </div>
    </div>
    <div
        class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-28 overflow-hidden bg-gray-800 dark:border-l">
        <!-- Background - @formatter:off -->
        <!-- Rings -->
        <svg class="absolute inset-0 pointer-events-none" viewBox="0 0 960 540" width="100%" height="100%"
            preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- Dots -->
        <svg class="absolute -top-16 -right-16 text-gray-700" viewBox="0 0 220 192" width="220" height="192"
            fill="none">
            <defs>
                <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20"
                    patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                </pattern>
            </defs>
            <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
        </svg>
        <!-- @formatter:on -->
        <!-- Content -->
        <div class="z-10 relative w-full max-w-2xl">
            <div class="text-7xl font-bold leading-none text-gray-100">
                <div>{{ "sign-in.welcome" | transloco }}</div>
                <div>PIIMA Job Online</div>
            </div>
            <div class="mt-6 text-lg tracking-tight leading-6 text-gray-400">
                {{ "sign-in.label" | transloco }}
            </div>
            <div class="flex items-center mt-8">
                <div class="flex flex-0 items-center -space-x-1.5">
                    <img class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/piima/piima-4.jpg" />
                    <img class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/piima/piima-3.jpg" />
                    <img class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/piima/piima-2.jpg" />
                    <img class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                        src="assets/images/piima/piima-1.jpg" />
                </div>
                <div class="ml-4 font-medium tracking-tight text-gray-400">
                    {{ "sign-in.text" | transloco }}
                </div>
            </div>
        </div>
    </div>
</div>